var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMwCloudsLp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1783.3 209.7",
    style: {
      enableBackground: "new 0 0 1783.3 209.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFE0FF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1573.9,89.6c-61.9-43.8-110.8,19-110.8,19s-16.7-98.6-107-107.7c-75.3-7.6-115,35.9-131.6,61.5 c-105.7-85.4-187.4,27.2-187.4,27.2c-61.9-43.8-110.8,19-110.8,19S909.6,10,819.3,0.9C713.7-9.8,678,80.1,678,80.1 c-13.5-7.9-25.1-11.3-35-11.8C534-28.1,448.6,89.6,448.6,89.6c-61.9-43.8-110.8,19-110.8,19S321.1,10,230.8,0.9 C125.2-9.8,89.5,80.1,89.5,80.1c-38.3-22.5-61.6-8.9-74.8,7.8C5,100.1,0,115.4,0,131.1v77.7h588.5H658h467.3h121.2h536.8v-74.3 c0-57-45.9-104.3-103-104C1616.6,30.6,1573.9,89.6,1573.9,89.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMwCloudsLp);
export default __webpack_public_path__ + "static/media/MW_Clouds-LP.357cfc1fed03db32a1150dbe5a5eeafd.svg";
export { ForwardRef as ReactComponent };